import coverPhoto from '../assets/hotspot/celebrationCover/Chile_Independance_Day.jpg';
import claudiaImage from '../assets/hotspot/headerImages/claudia-s.jpg';
import celebrationThumbnail1 from '../assets/hotspot/celebrationPerformances/Claudia_learn.jpg';
import celebrationThumbnail2 from '../assets/hotspot/celebrationPerformances/Claudia_concert.jpg.jpeg';

export const chileIndependenceDay = {
  celebrationTitle: 'Chile Independence Day',
  startDate: '09-18',
  endDate: '09-18',
  filterValue: 'chile-independence-day',
  displayDate: 'September 18',
  celebrationImage: coverPhoto,
  description: 'People in Chile celebrate the country\'s independence from Spain every year on September 18. The weather in Chile in September is beautiful, and people often celebrate their national holiday outdoors—sharing food, enjoying the traditional dances, playing friendly games, and watching Chilean horse racing.',
  celebrationVideos: [
    {
      videoLink: 'https://vimeo.com/1105184097?fl=pl&fe=sh',
      videoImage: celebrationThumbnail1,
      songTitle: 'El Derecho de Vivir en Paz',
      artistName: 'Claudia',
      videoTags: [
        {
          tag: 'Chile Independence Day',
        },
      ],
      songDescription: '"El Derecho de Vivir en Paz" ("The Right to Live in Peace") is a famous Chilean song that shares a message of peace, kindness, and fairness for all people. The song has become an important symbol of hope and unity for people around the world.',
    },
    {
      videoLink: 'https://vimeo.com/1105182774?fl=pl&fe=vl',
      videoImage: celebrationThumbnail2,
      songTitle: 'El Derecho de Vivir en Paz',
      artistName: 'Claudia',
      videoTags: [
        {
          tag: 'Chile Independence Day',
        },
      ],
    },
  ],
  artistsWhoCelebrate: [
    {
      artistName: 'Claudia',
      artistImage: claudiaImage,
    },
  ],
};
